import { render, staticRenderFns } from "./educateDialogPartner.vue?vue&type=template&id=05899a66&scoped=true"
import script from "./educateDialogPartner.vue?vue&type=script&lang=js"
export * from "./educateDialogPartner.vue?vue&type=script&lang=js"
import style0 from "./educateDialogPartner.vue?vue&type=style&index=0&id=05899a66&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05899a66",
  null
  
)

export default component.exports